













































import Vue, { PropType } from "vue";
import { NativeHealthState } from "@/utils/healthBridgeSchemas";
import { HealthPocViewModel } from "@/utils/healthPocViewAdapter";
import HealthActivitiesPanel from "./HealthActivitiesPanel.vue";
import HealthAuthorizationNotice from "./HealthAuthorizationNotice.vue";
import HealthDashboardHeader from "./HealthDashboardHeader.vue";
import HealthDayPanel from "./HealthDayPanel.vue";
import HealthError from "./HealthError.vue";
import HealthInsightsLink from "./HealthInsightsLink.vue";
import HealthSleepPanel from "./HealthSleepPanel.vue";
import HealthSyncProgress from "./HealthSyncProgress.vue";
import HealthTabs from "./HealthTabs.vue";

type HealthTab = "day" | "sleep" | "activities";

export default Vue.extend({
  name: "HealthDashboard",
  components: {
    HealthActivitiesPanel,
    HealthAuthorizationNotice,
    HealthDashboardHeader,
    HealthDayPanel,
    HealthError,
    HealthInsightsLink,
    HealthSleepPanel,
    HealthSyncProgress,
    HealthTabs
  },
  props: {
    view: { type: Object as PropType<HealthPocViewModel>, required: true },
    state: { type: Object as PropType<NativeHealthState | null>, default: null },
    providerLabel: { type: String, required: true },
    actionPending: { type: Boolean, default: false },
    error: { type: String, default: "" }
  },
  data: () => ({ activeTab: "day" as HealthTab }),
  computed: {
    authorization(): string {
      return this.state?.authorization ?? "not_determined";
    },
    hasSummary(): boolean {
      return Boolean(this.state?.summary);
    },
    showSyncProgress(): boolean {
      return Boolean(this.state && (this.state.status === "syncing" || this.state.sync.pendingEvents > 0));
    }
  },
  methods: {
    abrirInsights() {
      this.$router.push({ name: "insightsSaude.lista" });
    }
  }
});
